var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"p-0",attrs:{"size":"small","title":"版本分布图"}},[_c('div',{staticClass:"area-chart"},[_c('e-chart',{staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.options,"autoresize":"","dom-id":"opensource-version-chart"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }